<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <notifications />
        <form @submit.prevent="login">
          <div class="form-group row">
            <label
              for="email"
              class="col-sm-4 col-form-label text-md-right"
            >E-mail Address</label>

            <div class="col-md-6">
              <input
                id="email"
                v-model="email"
                type="email"
                class="form-control"
                name="email"
                required
                autofocus
              >
            </div>
          </div>
          <div class="form-group row">
            <label
              for="password"
              class="col-md-4 col-form-label text-md-right"
            >Password</label>

            <div class="col-md-6">
              <input
                id="password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                spellcheck="false"
                autocorrect="false"
                autocapitalize="none"
                autocomplete="current-password"
                class="form-control"
                name="password"
                required
              >
              <span
                :class="['fa fa-fw field-icon text-muted', eyeIconState]"
                @click="togglePasswordVisibility"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-8 offset-md-4">
              <button
                type="submit"
                class="btn btn-primary"
              >
                Login
              </button>

              <router-link
                class="btn btn-link"
                :to="{name: 'forgot-password'}"
              >
                Forgot your Password?
              </router-link>
            </div>
          </div>
          <hr>
          <div class="form-group row mb-0">
            <div class="col-12 text-center">
              Don't have an account?
              <router-link :to="{ name: 'signup'}">
                Sign up today!
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: null,
      password: null,
      showPassword: false
    }
  },
  computed: {
    eyeIconState(){
      return this.showPassword ? 'fa-eye-slash' : 'fa-eye';
    }
  },
  methods: {
    login () {

      this.$store.dispatch('notifications/clear');

      this.$store.dispatch('user/login', {email: this.email, password: this.password}).then(() => {
        // 'free' and 'individual' will be forwarded to Food Tracker page, otherwise to Profile
        let loginLandingPage = 'profile';
        switch (this.$store.state.user.user.type) {
          case 'free':
          case 'individual':
          loginLandingPage = 'food-tracker';
            break;
          case 'food_service_full':
            loginLandingPage = 'food-service-resources';
            break;
        }

        this.$router.push(this.$route.query.redirect || {name: loginLandingPage});
      }).catch((err) => {
        this.$store.dispatch('notifications/setError', 'Please check your credentials and try again.');
      })
    },
    togglePasswordVisibility(){
      this.showPassword = !this.showPassword;
    }
  }
}
</script>

<style lang="scss" scoped>
.field-icon {
  float: right;
  margin-right: 9px;
  margin-top: -27px;
  position: relative;
  z-index: 2;
}
</style>
